import React, { useState } from 'react'

import { Card } from 'antd'
import { faEdit, faTrash, faSave, faBan, faCopy } from '@fortawesome/pro-solid-svg-icons'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { Quota } from '../../../../utils/entities/quota'
import TooltipIconButton from '../../../../Components/antd/Buttons/TooltipIconButton'
import PopoverIconButton from '../../../../Components/antd/Buttons/PopoverIconButton'
import QuotaForm from '../../../../Providers/Forms/QuotaForm/QuotaForm'
import useQuota from '../../../../utils/api/hooks/useQuota'
import { getUser } from '../../../../reducers/UserReducer'

const mapStateToProps = state => ({ user: getUser(state.getUser), t: getTranslate(state.locale) })

const QuotaCard = ({ mode, quota, studentPathways, user, onChange, t }) => {
  const [editionMode, setEditionMode] = useState(false)
  const [currentQuota, setCurrentQuota] = useState(new Quota(quota))
  const [initialQuota, setInitialQuota] = useState(null)

  const quotaHandler = useQuota({ callback: onChange })

  const handleSave = () => {
    setEditionMode(false)

    quotaHandler.upsert(new Quota(currentQuota))
  }

  const handleCancel = () => {
    setCurrentQuota({ ...initialQuota })
    setEditionMode(false)
  }

  const handleEdit = () => {
    setEditionMode(true)
    setInitialQuota({ ...currentQuota })
  }

  const editActions = [
    <TooltipIconButton
      key='card-save-button'
      title={t('common.save')}
      onClick={handleSave}
      disabled={false}
      icon={faSave}
    />,
    <TooltipIconButton
      key='card-cancel-button'
      title={t('common.cancel')}
      onClick={handleCancel}
      icon={faBan}
    />
  ]
  const displayActions = [
    <TooltipIconButton
      key='card-edit-button'
      title={t('common.edit')}
      onClick={handleEdit}
      icon={faEdit}
    />,
    <TooltipIconButton
      key='card-duplicate-button'
      title={t('common.duplicate')}
      onClick={() => quotaHandler.upsert(new Quota({ ...currentQuota, id: -1 }))}
      icon={faCopy}
    />,
    <PopoverIconButton
      key='card-trash-button'
      content='Are you sure you want to delete this quota?'
      title={t('common.delete')}
      tooltipTitle='common.delete'
      type='danger'
      onConfirm={() => quotaHandler.delete(new Quota(currentQuota))}
      icon={faTrash}
    />
  ]

  return (
    <Card
      style={{ width: '100%', marginBottom: '10px' }}
      actions={editionMode ? editActions : displayActions}
    >
      {currentQuota && (
        <div className='allocation-quota-card-body'>
          <QuotaForm
            data={currentQuota}
            disabled={!editionMode}
            mode={mode}
            studentPathways={studentPathways}
            onChange={setCurrentQuota}
          />
        </div>
      )}
    </Card>
  )
}

export default connect(mapStateToProps)(QuotaCard)
